import { render, staticRenderFns } from "./UpdatePhoneNumberForm.vue?vue&type=template&id=1887fc79"
import script from "./UpdatePhoneNumberForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePhoneNumberForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports